import { useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { useDropdownMenuTooltip } from '../hooks/useDropdownMenuTooltip';
import config from '../../../../../config.json';

const PortingTypeField = ({
    darkMode,
    values,
    setFieldValue,
    errors,
    touched,
    ufNumBlockPortingType,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const { tooltipPlacement, onMouseDown, onMenuClose } =
        useDropdownMenuTooltip();

    // DropDown matches options by `id`, so mirror `value` onto `id` here.
    const portingOptions = (
        values.companyID ? config.numbers.porting : [{ value: 0, name: 'None' }]
    ).map((option) => ({ ...option, id: option.value }));
    console.log({ values });
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!errors.numberBlockPortingType &&
                touched.numberBlockPortingType
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Number Block Porting Type
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the porting type for this number block.
                    </Text>
                </Box>
                <Box flex="1" minWidth={0} onMouseDown={onMouseDown}>
                    <Field
                        component={DropDown}
                        id="numberBlockPortingType"
                        name="numberBlockPortingType"
                        shownValue="name"
                        currentId={values.numberBlockPortingType}
                        handleSelectChange={(item) =>
                            setFieldValue(
                                'numberBlockPortingType',
                                item?.id ?? 0,
                            )
                        }
                        darkMode={darkMode}
                        data={portingOptions}
                        walkthroughId={ufNumBlockPortingType}
                        width="100%"
                        onMenuClose={onMenuClose}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the porting type for this number block."
                        ariaLabel="porting-type-tip"
                        left="25px"
                        top="25px"
                        placement={tooltipPlacement}
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PortingTypeField;
